const toBlob = (base64, mimeContentType, noBom) => {
  // NOTE: 日本語の文字化けに対処するためBOMを作成
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
  const bin = window.atob(base64);
  const buffer = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) {
    buffer[i] = bin.charCodeAt(i);
  }
  if (noBom) {
    return mimeContentType ? new Blob([buffer.buffer], {
      type: mimeContentType,
    }) : new Blob([buffer.buffer]);
  }
  return mimeContentType ? new Blob([bom, buffer.buffer], {
    type: mimeContentType,
  }) : new Blob([bom, buffer.buffer]);
}

const download = (base64Data, name, mimeContentType, noBom) => {
  if (window.navigator.msSaveBlob) {
    // for IE
    window.navigator.msSaveBlob(toBlob(base64Data, mimeContentType, noBom), name);
    return;
  }
  const url = window.URL.createObjectURL(toBlob(base64Data, mimeContentType, noBom));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { download };
